import {makeAutoObservable} from "mobx";
import type {BagStore} from "../BagStore";
import type ProfileStore from "../ProfileStore";
import type {MithraMaterializedApi} from "../../services/MithraMaterializedApi";
import type {SynergyStore} from "../SynergyStore";

/**
 * The synergy store for common categories
 */
export class CommonCategoriesDelegate {
    readonly numberTotalCategoriesLeft: number;
    readonly numberTotalCategoriesRight: number;
    readonly numberTotalCommonCategories: number;
    readonly totalSpendCommonCategories: number;
    readonly numberCommonCategoriesLeft: number;
    readonly numberCommonCategoriesRight: number;
    readonly totalCategoriesSpendLeft: number;
    readonly totalCategoriesSpendRight: number;
    readonly commonCategoriesSpendLeft: number;
    readonly commonCategoriesSpendRight: number;

    // noinspection JSUnusedLocalSymbols
    constructor(
        private synergyStore: SynergyStore,
        // private approvalStore: ApprovalStore,
        // private auth: AuthStore,
        private bagStore: BagStore,
        private matApi: MithraMaterializedApi,
        private profileStore: ProfileStore,
    ) {
        makeAutoObservable(this)
        this.numberTotalCategoriesLeft = this.profileStore.p.hardcodedNumberTotalCategoriesLeft || -1;
        this.numberTotalCategoriesRight = this.profileStore.p.hardcodedNumberTotalCategoriesRight || -1;
        this.numberTotalCommonCategories = this.profileStore.p.hardcodedNumberTotalCommonCategories || -1;
        this.totalSpendCommonCategories = this.profileStore.p.hardcodedTotalSpendCommonCategories || -1;
        this.numberCommonCategoriesLeft = this.profileStore.p.hardcodedNumberCommonCategoriesLeft || -1;
        this.numberCommonCategoriesRight = this.profileStore.p.hardcodedNumberCommonCategoriesRight || -1;
        this.totalCategoriesSpendLeft = this.profileStore.p.hardcodedTotalCategoriesSpendLeft || -1;
        this.totalCategoriesSpendRight = this.profileStore.p.hardcodedTotalCategoriesSpendRight || -1;
        this.commonCategoriesSpendLeft = this.profileStore.p.hardcodedCommonCategoriesSpendLeft || -1;
        this.commonCategoriesSpendRight = this.profileStore.p.hardcodedCommonCategoriesSpendRight || -1;
    }
}
